import cookies from './cookies';
import { getCurrentScriptBasePath } from './utils';

const basePath = getCurrentScriptBasePath();

if (!basePath) {
  throw new Error("Unable to determine currentScript basePath, webpack's publicPath is not specified");
}

// @ts-ignore
__webpack_public_path__ = basePath;

const WRP_ID = 'welcomeMessagesContainer';

async function initWelcomeMessages() {
  const bootstrap = (await import('@central-products/welcome-messages-bootstrapper')).default;
  const { WelcomeMessagesProvider } = await import('@central-products/welcome-messages-provider');
  const { defaultHandler } = await import('@central-products/welcome-messages-default-handler');
  const { render } = await import('react-dom');
  const React = await import('react');

  const transport = await bootstrap({ ignoreAccountActions: !_WEBPACK_DEFINED_INIT_ACCOUNT_ACTION });
  defaultHandler({ transport });

  const wrp = document.createElement('div');
  wrp.setAttribute('id', WRP_ID);

  render(<WelcomeMessagesProvider />, wrp);
  document.body.appendChild(wrp);
}

if (!document.getElementById(WRP_ID)) {
  initWelcomeMessages();
}

// tslint:disable-next-line:no-any
cookies((window as any).WH.messageBus);
